const translations = {
  "az": {
    home: "ANA SƏHİFƏ",
    collections: "KOLLEKSİYALAR",
    blog: "BLOQ",
    about: "HAQQIMIZDA",
    contact: "BİZİMLƏ ƏLAQƏ",
    visit: "Mağazamızı ziyarət edin",
    address: "Ünvan",
    phone: "Mobil",
    email: "E-poçt",
    openTime: "İş saatları",
    name: "Ad",
    last: "Soyad",
    email: "E-poçt",
    radio: "Çatdırılma üsulu :",
    radio1: "Mağazadan əldə etmək",
    radio2: "Ünvana çatdırılma",
    address1: "Yaşadığınız ünvanı daxil edin",
    orderNote: "Sifariş notu",
    orderDesc: "Sifarişiniz haqqında qeydlər, məs. çatdırılma üçün xüsusi qeydlər.",
    orders: "Sifarişiniz",
    product: "Məhsul",
    orderTotal: "Sifariş Cəmi",
    placeOrder: "Sifarişi təsdiqləyin",
    billing: "Ödəniş Təfərrüatları",
    orders: "Sifarişiniz",
    total: "Ümumi",
    addresscontact: "Azərbaycan Bakı şəhəri, Ağ Şəhər, Qarabağ Atları Meydanı",
    contactDesc: "Vertu, peşəkar sənətkarlıq və bənzərsiz materialları innovativ texnologiya və unikal xidmətlərlə birləşdirərək müştəriləri üçün dünyanın ən gözəl mobil telefon təcrübəsini təqdim etməyi hədəfləyir.",
    message: "Mesajınız",
    readmore: "Daha çox",
    copyright: "Bu saytın bütün müəllif hüquqları qorunur.",
    innovation: "XÜSUSİ BİR SƏYAHƏT",
    shopnow: "Daha ətraflı",
    color: "Rəng",
    quantity: "Miqdar",
    addtocart: "Səbətə əlavə et",
    desc: "TƏSVİR",
    charac: "XÜSUSİYYƏTLƏRİ",
    basket: "Səbət",
    monday: "Bazar ertəsi",
    sunday: "Bazar",
    categories: "Kateqoriyalar",
    all: "Bütün modellər",
    min: "Min",
    max: "Maks",
    sort: "Daha çox filtr",
    sort1: "Ad (A-Z)",
    sort2: "Ad (Z-A)",
    sort3: "Əvvəlcə bahalı",
    sort4: "Əvvəlcə ucuz",
    quickadd: "Sürətli əlavə edin",
    quickview: "Görünüş",
    aboutTitle: "LÜKS TELEFONLARDA İNNOVASIYANIN  İZLƏRI.",
    aboutTitle1: "Azərbaycanda ilk rəsmi Vertu mağazası",
    aboutdesc: "Vertu telefonları incə sənətkarlığın ən müasir texnologiya ilə üst-üstə düşdüyü lüksün son ifadəsidir. Hər bir telefon İngiltərədə yüksək keyfiyyətli materiallardan, o cümlədən praktiki olaraq cızıqlara davamlı sapfir kristalından, möhkəm 5-ci dərəcəli titandan və dəbdəbəli əl ilə tikilmiş dəridən istifadə edilməklə diqqətlə hazırlanır. Bu elementlər yalnız hər bir cihazı vizual olaraq heyrətamiz edir, həm də bənzərsiz davamlılıq və uzunömürlülük təmin edir. <br> <br> Hər bir Vertu telefonunun qəlbində hətta ən tələbkar tapşırıqlar üçün qüsursuz və həssas performans təmin edən güclü Qualcomm prosessoru dayanır. Safir kristalla qorunan displey müstəsna aydınlıq və canlılıq təqdim edərək, hər bir təsvir və videonu canlandırır. Qabaqcıl kamera sistemi istənilən işıqlandırma şəraitində mükəmməl fotoşəkillər çəkmək üçün hazırlanmışdır ki, bu da onu həm gündəlik anlar, həm də qeyri-adi təcrübələr üçün ideal edir.<br> <br> Batareya bütün gün istifadə üçün nəzərdə tutulmuşdur, sürətli doldurma imkanları heç vaxt enerjisiz qalmamağınızı təmin edir. Təcrübəni tamamlamaq üçün hər bir Vertu telefonunda fərdiləşdirilmiş yardım və dünya üzrə unikal təcrübələrə eksklüziv çıxış təklif edən 24/7 konsyerj xidməti daxildir. Vertu telefonları sadəcə cihazlar deyil, onlar statusun, zərifliyin və misilsiz lüksün simvoludur.",
    aboutdesc1: 'Azərbaycanda ilk rəsmi Vertu mağazasının açılması keyfiyyət və zərifliyə sadiqlik, eləcə də ölkədə dəbdəbəli və yüksək səviyyəli cihazlar bazarının inkişafında irəliyə doğru addım deməkdir. Bu, həm də onu təsdiqləyir ki, Azərbaycan ağıllı istehlakçıların tələblərinə cavab verməyə çalışan qlobal brendlər üçün getdikcə daha cəlbedici bir məkana çevrilir.Bu mağaza müştərilərin Vertu məhsullarının geniş çeşidini araşdıra, ekspert məsləhətləri ala və brendin statusuna uyğun xidmət səviyyəsini yaşaya biləcəkləri yerdir.<br> <br> "MyGroup Holding" MMC Vertu telefonlarının Azərbaycanda eksklüziv reselleri kimi rəsmi tərəfdaşlığını elan etməkdən qürur duyur. Müstəsna məhsul və xidmətlərin təqdim edilməsi ilə tanınan MyGroup Holding MMC dünyanın ən dəbdəbəli brendlərinin şəxsi kolleksiyasını idarə edir. MyGroup Holding MMC vasitəsilə Vertu telefonu satın aldığınız zaman sizə orijinallıq və misilsiz müştəri xidməti zəmanət verilir. Yalnız "MyGroup Holding" MMC-də mövcud olan Vertu ilə lüks və qabaqcıl texnologiyanın mükəmməl qarışığını yaşayın. <br> <br> "MyGroup Holding" MMC, Azərbaycanda müxtəlif sənaye sahələrində mükəmməlliyə və innovasiyalara sadiqliyi ilə seçilən aparıcı müəssisələrdən biridir. Pərakəndə satış, texnologiya və lüks malları əhatə edən müxtəlif portfelə sahib olan "MyGroup Holding" MMC müştərilərinə ən yüksək keyfiyyət və xidmət standartlarını çatdırmağa sadiqdir. Şirkətimiz, güclü tərəfdaşlıqların inkişaf etdirilməsi və seçici müştərilərimizin unikal ehtiyaclarına cavab verən eksklüziv təkliflərin tərtib edilməsi ilə hər zaman fəxr edir.',
    pages: "Səhifələr",
    about1: "Haqqımızda",
    blog1: "Bloq",
    contact1: "Bizimlə Əlaqə",
    privace: "Şərtlər və Qaydalar",
    privacyDesc: 'Bu istifadə şərtləri VERTUAZ.COM vebsaytından və mobil proqramlardan istifadənizi tənzimləyir. Bu İstifadə Şərtlərində biz VERTU terminindən (və "biz" və "bizim") VERTU-nun qeydiyyatdan keçmiş ünvandakı baş ofisinə və onun filiallarına istinad etmək üçün istifadə edirik. <br> <br> Saytı istifadə etməzdən əvvəl bu istifadə şərtlərini diqqətlə oxuyun. Saytdan istifadə etməklə siz bu İstifadə şərtlərinə öz təsdiqinizi və razılığınızı bildirirsiniz. Əgər bu İstifadə şərtləri ilə razı deyilsinizsə, o zaman Saytdan istifadəni davam etdirməyə icazəniz yoxdur.',
    privacy1: "ƏQLİ MÜLKİYYƏT HÜQUQLARININ MÜDAFİƏSİ",
    privacyDesc1: 'Ümumiyyətlə, Saytlarda görünən bütün ticarət nişanları, loqolar və xidmət nişanları (birlikdə "Ticarət nişanları") qeydə alınmış, qeydiyyatdan keçməmiş və ya başqa şəkildə qorunan VERTU ticarət nişanlarıdır və ya VERTU tərəfindən üçüncü tərəflər tərəfindən istifadə üçün lisenziyaya malikdir. Digər ticarət nişanları mülkiyyət nişanlarıdır və müvafiq sahibləri üçün qeydiyyata alınır. Bu İstifadə Şərtlərində açıq şəkildə nəzərdə tutulmuş hallar istisna olmaqla, Saytın heç bir hissəsi və heç bir məzmun kopyalana, təkrar istehsal oluna, yenidən nəşr oluna, yüklənə, yerləşdirilə, açıq nümayiş etdirilə, kodlaşdırıla, tərcümə oluna, ötürülə və ya hər hansı bir şəkildə (“güzgü” daxil olmaqla) paylana bilməz. VERTU-nun əvvəlcədən açıq yazılı razılığı olmadan nəşr və ya paylama və ya hər hansı kommersiya müəssisəsi üçün hər hansı digər kompüter, server, vebsayt və ya digər vasitə.',
    collections1: "Kolleksiyalar",
    innovationDesc: "HƏR ZAMAN FƏRQLİ, ZİNƏTLİ və GÖZƏL",
    luxuryDesign: "LÜKS DİZAYN",
    handmake: "ƏL İŞİ",
    person: "SAHİBƏ ÖZƏL XİDMƏTLƏR",
    luxuryDesc: "Vertu telefonları, lüks telefonların arasında yer alır. Özəl dizaynları, dəyərli materialları və yüksək texnologiyaları ilə fərqlənir.",
    handDesc: "Hər detalın diqqətlə hazırlanması, mobil telefonun estetik və funksional olmasına diqqət yetirir.",
    personDesc: "Vertu telefonları, sahibinə yüksək səviyyədə istifadə təcrübəsi təmin edir. Keyfiyyətli materiallar, inkişaf etmiş funksiyalar və telefonun gözəl görünüşü bir araya gəlir!",
    homeHelmet: "Vertu | Azərbaycandakı Rəsmi Distribyutor",
    invalid: "Zəhmət olmasa xananı doldurun",
    notcheckout: "Bizi seçdiyiniz üçün təşəkkür edirik! Qısa zaman ərzində sizinlə əlaqə saxlanılanacaq.",
    ordered: "Sifariş təfərrüatları :",
    checkout: "Sifariş",
    alert: "Sifarişiniz qeydə alındı.",
    remove: "Sil",
    empty: "Səbətiniz boşdur.",
    noresult: "Heç bir nəticə tapılmadı",
    buynow: "İNDİ AL",
    productName: "Məhsul adı",
    price: "Qiymət",
    payment: "Ödəniş",
    cash: "Nağd ödəniş",
    vertumodel: "VERTU MODELLƏRİ",
    paymentMethod: "Ödəniş üsulunu seçin :",
    paymentDoor: "Qapıda ödəniş üsulu",
    paymentOnline: "Onlayn ödəniş üsulu",
    paymentOnlayn: "Onlayn ödəniş",
    notnote: "Sifariş notu qeyd olunmayıb",
    search: "Axtarış...",
    vertuTitle: "VERTUNUN",
    vertuSpan: "SEHRİ",

    springBloom: "Vertu Metavertu Max",
    spring1: "Həyatınızı maksimum yaşayın!",

    homeSlider4: "Vertu IronFlip YG Navy Blue Alli",
    homeSlider4Desc: "Modern flip texnologiyası və nadir alligator dərisi bir cihazda!",

    homeSlider5: "Vertu AI Ring Floating Light",
    homeSlider5Desc: "Dünyanın ən nadir materialları, yalnız seçilmişlər üçün",

    explore: "Daha Çox Kəşf Edİn",
    collecDesc: "Hər Toxunuşda Bəxtİn və Zərİflİyİn Sehrİnİ Kəşf Edİn",
    telefon: "Telefonlar",
    aksesuar: "Aksesuarlar",
    hediyye: "Hədiyyələr",

    limited: "MƏHDUD TƏKLİF",

    homeSlider3: "Vertu Quantum Flip Silver",
    homeSlider3Desc: "Hər detalda güc, hər baxışda prestij!",

    homeSlider2: "Vertu OWS Headset White 18K Gold",
    homeSlider2Desc: "Swarovski daşlarının zərif parıltısı",

    homeSlider5: "Hər toxunuşda zərİflİk",

    homeSlider6: "Agent Q tezliklə istifadəyə veriləcək",
    homeSlider6Desc: `    Nadir Ağ Şahindən ilhamlanıb — bu, hakimiyyətin, nadirliyin və suveren gücün simvoludur.
Əl işi dəbdəbəni kognitiv texnologiya ilə birləşdirir.
Sadəcə bir cihaz deyil, düşünən bir yoldaşdır.
Aydınlıq, gizlilik və özünə inam üçün hazırlanıb.` ,
  
  ver1Title:"Yenİ Era Alphafold",
  ver2Title:"Vertu Alphafoldu",
  ver3Title:"Bənzərsiz seçim",

  ver1Desc:"Zövqü ilə iz qoyanlar üçün",
  ver2Desc:"Zərifliyin hökmü",
  ver3Desc:"Hər anınıza dəyər qatan eksklüziv texnologiya",


  },
  "en": {
    home: "ГЛАВНАЯ СТРАНИЦА",
    collections: "КОЛЛЕКЦИИ",
    blog: "БЛОГ",
    about: "О НАС",
    contact: "СВЯЗАТЬСЯ С НАМИ",
    visit: "Посетите наш магазин",
    address: "Адрес",
    phone: "Телефон",
    email: "Электронная почта",
    openTime: "Часы работы",
    name: "Имя",
    last: "Фамилия",
    phone: "Телефон",
    email: "Электронная почта",
    radio: "Способ доставки :",
    radio1: "Купите в магазине",
    radio2: "Доставка по адресу",
    address1: "Введите адрес вашего проживания",
    orderNote: "Примечание к заказу",
    orderDesc: "Примечания к вашему заказу, например, особые примечания по доставке.",
    orders: "Ваш заказ",
    product: "Продукт",
    orderTotal: "Заказ Всего",
    placeOrder: "Подтвердите свой заказ",
    billing: "Реквизиты для выставления счетов",
    orders: "Ваш заказ",
    total: "Общий",
    addresscontact: "Баку, Белый Город, Площадь Карабахских Лошадей",
    contactDesc: "Vertu стремится предоставить своим клиентам самый изысканный опыт использования мобильных телефонов в мире, сочетая профессиональное мастерство и уникальные материалы с инновационными технологиями и исключительным обслуживанием.",
    message: "Ваше сообщение",
    readmore: "Больше",
    copyright: "Все авторские права на этот сайт защищены.",
    innovation: "ОСОБЕННОЕ ПУТЕШЕСТВИЕ",
    shopnow: "Подробнее",
    color: "Цвет",
    quantity: "Количество",
    addtocart: "Добавить в корзину",
    desc: "Описание",
    charac: "ХАРАКТЕРИСТИКИ",
    basket: "Корзина",
    monday: "Понедельник",
    sunday: "Воскресенье",
    categories: "Категории",
    all: "Все модели",
    min: "Мин",
    max: "Макс",
    sort: "Разберитесь с этим",
    sort1: "Имя (А-З)",
    sort2: "Имя (З-А)",
    sort3: "От дорогого к дешевому",
    sort4: "От дешевого к дорогому",
    quickadd: "Быстрое добавление",
    quickview: "Появление",
    pages: "Страницы",
    about1: "О нас",
    blog1: "Блог",
    contact1: "Связаться с нами",
    privace: "Условия и положения",
    privacyDesc: 'Настоящие условия использования регулируют использование Вами веб-сайта VERTUAZ.COM и мобильных приложений. В настоящих Условиях использования мы используем термин VERTU (а также «мы» и «наш») для обозначения головного офиса VERTU по зарегистрированному адресу и ее филиалов. <br> <br> Пожалуйста, внимательно прочитайте эти условия использования перед использованием сайта. Используя Сайт, вы признаете и соглашаетесь с настоящими Условиями использования. Если вы не согласны с настоящими Условиями использования, вам не разрешается продолжать использовать Сайт.',
    privacy1: 'ЗАЩИТА ПРАВ ИНТЕЛЛЕКТУАЛЬНОЙ СОБСТВЕННОСТИ',
    privacyDesc1: "В целом, все товарные знаки, логотипы и знаки обслуживания (совместно именуемые «Товарные знаки»), представленные на Сайтах, являются зарегистрированными, незарегистрированными или иным образом защищенными товарными знаками VERTU или лицензированы VERTU для использования третьими лицами. Другие товарные знаки являются собственностью и зарегистрированы соответствующими владельцами. За исключением случаев, прямо предусмотренных настоящими Условиями использования, никакая часть Сайта и никакое содержимое не могут быть скопированы, воспроизведены, переизданы, загружены, размещены, публично показаны, закодированы, переведены, переданы или каким-либо образом (включая используя «зеркало») не могут быть запрещены, быть распределены, опубликованы или распространены на любом другом компьютере, сервере, веб-сайте или другом носителе для любого коммерческого предприятия без предварительного письменного согласия VERTU.",
    collections1: "Коллекции",
    aboutTitle: "ПРОЯВЛЕНИЕ ИННОВАЦИЙ В УСТРОЙСТВАХ РОСКОШИ.",
    aboutTitle1: "Первый официальный магазин Vertu в Азербайджане.",
    aboutdesc: "Телефоны Vertu сочетают в себе исключительное мастерство изготовления с новейшими технологиями, создавая телефоны, которые выделяются как дизайном, так и функциональностью. Каждый телефон Vertu — это шедевр, тщательно изготовленный опытными мастерами из Великобритании с использованием лучших материалов, включая сапфировое стекло, титан и кожу премиум-класса. Эти материалы выбираются не только из-за их эстетичного внешнего вида, но также из-за их долговечности и качества, благодаря чему каждое устройство будет таким же прочным, как и красивым.<br> <br> Помимо интересного дизайна, телефоны Vertu являются воплощением современных технологий. Оснащенные высокопроизводительными процессорами, кристально чистыми экранами и усовершенствованной системой камер, эти телефоны обеспечивают уникальный пользовательский опыт. Безопасность лежит в основе предложения Vertu: встроенное шифрование и безопасная связь обеспечивают защиту вашей конфиденциальности.<br> <br> Что действительно отличает Vertu, так это исключительные услуги, которые она предоставляет. Каждый телефон оснащен специальной службой консьержа, доступной круглосуточно и без выходных, предлагающей индивидуальную помощь и доступ к уникальным впечатлениям, соответствующим вашему образу жизни. Vertu — это не просто телефон; Это выражение элегантности, силы и привилегий.",
    aboutdesc1: 'Открытие первого официального магазина Vertu в Азербайджане означает приверженность качеству и элегантности, а также шаг вперед в развитии рынка роскошных и высококлассных устройств в стране. Это также подтверждает, что Азербайджан становится все более привлекательным местом для мировых брендов, пытающихся удовлетворить запросы умных потребителей. В этом магазине покупатели могут ознакомиться с широким ассортиментом продукции Vertu, получить квалифицированную консультацию и оценить уровень обслуживания, соответствующий статусу бренда.<br> <br> ООО «MyGroup Holding» — одно из ведущих предприятий Азербайджана, отличающееся стремлением к совершенству и инновациям в различных отраслях. Благодаря разнообразному портфолио, охватывающему розничную торговлю, технологии и предметы роскоши, MyGroup Holding LLC стремится предоставлять своим клиентам самые высокие стандарты качества и обслуживания. Наша компания всегда гордилась развитием прочных партнерских отношений и разработкой эксклюзивных предложений, отвечающих уникальным потребностям наших взыскательных клиентов. <br> <br> Для нас большая честь, что ООО «MyGroup Holding» является официальным партнером и эксклюзивным продавцом телефонов Vertu в Азербайджане. Это партнерство отражает наше непоколебимое стремление предлагать на нашем рынке лучшие товары класса люкс. Благодаря этому сотрудничеству наши клиенты получают оригинальные телефоны Vertu вместе с сервисом высокого уровня от ООО «MyGroup Holding».',
    innovationDesc: "Всегда Pазный, Элегантный и Красивый",
    luxuryDesign: "РОСКОШНЫЙ ДИЗАЙН",
    handmake: "РУЧНАЯ РАБОТА",
    person: "УСЛУГИ ДЛЯ ЧАСТНЫХ ПРЕДПРИНИМАТЕЛЕЙ",
    luxuryDesc: "Телефоны Vertu входят в число люксовых телефонов. Они выделяются своим уникальным дизайном, ценными материалами и высокими технологиями",
    handDesc: "Каждая деталь тщательно прорабатывается, чтобы мобильный телефон был как эстетически, так и функционально привлекательным.",
    personDesc: "Телефоны Vertu обеспечивают владельцу высокий уровень пользовательского опыта. Качественные материалы, продвинутые функции и элегантный внешний вид соединяются вместе!",
    homeHelmet: "Vertu | Официальный Дистрибьютор в Азербайджане",
    invalid: "Пожалуйста, заполните поле",
    notcheckout: "Спасибо, что выбрали нас! С вами свяжутся в ближайшее время.",
    ordered: "Детали заказа :",
    checkout: "Заказ",
    alert: "Ваш заказ зарегистрирован.",
    remove: "Удалить",
    empty: "Ваша корзина пуста",
    noresult: "Результат не найден",
    buynow: "купить сейчас",
    productName: "Название продукта",
    price: "Цена",
    payment: "Оплата",
    cash: "Оплата наличными",
    vertumodel: "Модели Верту",
    paymentMethod: "Выберите способ оплаты :",
    paymentDoor: "Способ оплаты у двери",
    paymentOnline: "Способ онлайн-оплаты",
    paymentOnlayn: "Онлайн оплата",
    notnote: "Нет записи о заказе",
    search: "Поиск...",
    vertuTitle: "МАГИЯ",
    vertuSpan: "ВЕРТУНА",

    springBloom: "Vertu Metavertu Max",
    spring1: "Живите свою жизнь на максимум!",

    homeSlider4: "Vertu IronFlip YG Navy Blue Alli",
    homeSlider4Desc: "Современная технология flip и редкая кожа аллигатора в одном устройстве!",
    homeSlider5: "Vertu AI Ring Floating Light",
    homeSlider5Desc: "Самые редкие материалы в мире — только для избранных",


    explore: "Исследуйте Больше",
    collecDesc: "Откройте для себя магию удачи и элегантности с каждым прикосновением",
    telefon: "Телефоны",
    aksesuar: "Аксессуары",
    hediyye: "Подарки",

    limited: "Ограниченное предложение",


    homeSlider3: "Vertu Quantum Flip Серебристый",
    homeSlider3Desc: "В каждой детали — сила, в каждом взгляде — престиж!",


    homeSlider2: "Vertu OWS Headset White 18K Gold",
    homeSlider2Desc: "Изящное сияние камней Swarovski",



    homeSlider5: "Изысканность в каждом прикосновении",

    homeSlider6: "Agent Q скоро будет запущен.",
    homeSlider6Desc: `    Вдохновлён редким Белым Соколом — символом власти, редкости и суверенной силы.
Соединяет ремесленную роскошь с когнитивными технологиями.
Это не просто устройство — это мыслящий спутник.
Создан для ясности, сдержанности и уверенности.`,

ver1Title: "Новая эра Alphafold",
ver2Title: "Vertu Alphafold",
ver3Title: "Непревзойдённый выбор",

ver1Desc: "Для тех, кто оставляет след своим вкусом",
ver2Desc: "Воплощение элегантности",
ver3Desc: "Эксклюзивные технологии, которые делают каждый момент особенным",

  }
}


export default translations;